module.exports = __webpack_public_path__ + "img/D&D-Elemente_Kreis_Kapitel4.9a58376c.svg";